<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box american-credit-partner">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<h1>Loan Calculator & Payment Estimator</h1>
							<button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Get the credit you deserve from a lender you can trust. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="american-credit-roi-head-img" src="../assets/imgs/American_Credit_Loancaculator_ROI.png" alt="American Credit Loancaculator ROI"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%; background: #053a7a;">
      <div class="container bluebg text-center">
        <br />
        <h2 class="display-5 text-whitee text-center font-weight-bolder">Estimate your asset-based loan monthly payment</h2>

        <div class="contexbox1 text-center">
          <br />
          <h5 class="text-whitee font-weight-bold">See a quick snapshot of your asset-based loan monthly installment payments.</h5>
          <h6 class="text-whitee">It’s always important to know what to expect before borrowing money. So, use our asset-based loan calculator to get an estimate of your monthly installment in principal repayment and interest payment on an American Credit<sup>®</sup> asset-based loan. You can adjust the term and initial principal amount to see the impact they may have on monthly payment.</h6>

          <h2
            id="loanCalculator"
            name="loanCalculator"
            class="display-5 text-whitee text-center font-weight-bolder"
          >Calculate your sample asset-based loan</h2>
          <br />
          <iframe
            src="/static/LoanCalculator/LoanCalculator.html"
            width="100%"
            height="988px"
            class="bg-light"
          ></iframe>
          <br />
          <br />
          <br />
        </div>
        <div class="contexbox text-center">
          <h6>
            To see exactly what your interest rate will be, please apply for your equipment financing or invoice financing loan now. Doing so is absolutely free, 
            will not affect your credit score and you are under no obligation to accept our offer of a loan or line of credit.
          </h6>
        </div>
        <br />
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform how-works">
        <div class="row how-works-button">
          <button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none; margin: 7px;">Apply Now</button>
          <button @click="this.window.open('https://youtu.be/JH96Q66Y4Hc','_blank')" style="background-color: #ffffff; color: rgb(84, 86, 255); font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: 1px solid rgb(84, 86, 255); margin: 7px;">Watch Demo</button>
        </div>
      </div>
    </div>

    <div style="width: 100%;">
      <div class="row user-feedback">
        <div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
        <div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
        <div class="container row user-feedback-content">
          <div class="col-12 col-lg-5 offset-lg-1 user-feedback-content-left">
            <img src="../assets/imgs/American_Credit_Team_Customer_Voice.png" alt="American Credit Team Customer Voice"/>
          </div>
          <div class="col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right">
            <img src="../assets/imgs/quote.png" alt="American Credit Team Customer Voice Quote">
            <p class="user-feedback-text">I need to spend my time meeting customers’ expectations, not on lengthy loan applications.</p>
            <br>
            <br>
            <p  class="user-feedback-name"><span style="color: #6d6d6d; font-weight: 300;">Laurie Townsend</span><br><span style="color: #3c3c3c; font-weight: 700;">Account Receivable Manager, Lone Star Uniform Services</span></p>
            <div class="user-feedback-button">
              <button @click="this.window.location.href='tel:1855-904-0188'">Let’s Talk</button>
              <p><span style="color: #3c3c3c; font-weight: 300;">Try us now. </span><span style="color: #3c3c3c; font-weight: 700;">See how we get you the money fast. </span><span style="color: #5456ff; font-weight: 700;"><a href="/get-start">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Financial Calculator - Payment Estimates | American Credit";
    meta.content = "Our Business Loan Calculator estimates your monthly payment & estimated interest. American Credit provides a fast & simple financing solution. Apply Now!";
    keywords.content = "Type of Loans, best business loans, online business loans, quick business loans California business loans";
  }
};
</script>

<style scoped lang="scss">
  @import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";

  .american-credit-roi-head-img {
    // width: 680px !important;
    margin-top: 0 !important;
  }
.pill-button.medium {
  min-width: 150px;
}

.pill-button {
  font-size: 18px;
  font-family: AvenirNext-DemiBold, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-style: normal;
  font-weight: 400;
  display: inline-block;
  padding: 15px 35px;
  border-radius: 30px;
  background-color: #fff;
  transition: background-color 0.5s ease;
  -webkit-appearance: none;
}

.pill-button,
.under-button {
  line-height: 1.5em;
  text-align: center;
}

.pill-button,
.pill-button:hover {
  color: #56c271;
  text-decoration: none;
}

.three-column {
  display: block;
}

.three-column::after {
  display: table;
}

.three-column .column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 31.76157%;
}

.three-column .column:last-child {
  margin-right: 0;
}

@media screen and (max-width: 767px) {

  .american-credit-roi-head-img {
    // width: 100% !important;
    margin-top: 0px !important;
    margin-bottom: 50px !important;
  }

  .three-column .column {
    float: left;
    display: block;
    margin-right: 7.42297%;
    width: 100%;
    margin-bottom: 30px;
  }

  .three-column .column:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button {
  padding: 10px 35px;
  border: 1px solid #7f7f7f;
  color: #7f7f7f;
  cursor: pointer;
  display: block;
  max-width: 170px;
  margin: 10px auto;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  input:focus,
.entrepreneurs-scholarship.scholarship-application
  .scholarship-form.right
  form
  button.submit:focus {
  outline: 0;
}

#roi-controller .roi-container {
  max-width: 900px;
}

#roi-controller .main-roi-calculator .calculate-section .h1-style {
  margin-bottom: 0;
}

#roi-controller .main-roi-calculator .calculate-section .h1-style sup {
  margin-left: -5px;
}

#roi-controller #rates-panel {
  padding: 40px 0;
  background-color: #fff;
}

#roi-controller #rates-panel .box .calculate-section .h1-style {
  text-align: center;
  color: #56c271;
}

#roi-controller #rates-panel .box .calculate-section p.roi-description {
  text-align: center;
  margin: 0 230px;
  padding-bottom: 15px;
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  #roi-controller #rates-panel .box .calculate-section p.roi-description {
    margin: 0;
  }
}

@media screen and (max-width: 767px) {
  .roi-iframe-mobile {
    height: 900px !important;
  }

  .compare-funding a {
    float: none;
  }

  #roi-controller #rates-panel {
    border-bottom: 1px solid #979797;
  }

  #roi-controller #rates-panel .box .calculate-section p.roi-description {
    margin: 0;
  }
}

#roi-controller #rates-panel .box .calculate-section p.roi-description a {
  font-family: AvenirNext-DemiBold;
}

#roi-controller #rates-panel .box .calculate-section p.roi-description a:hover {
  cursor: pointer;
}

#roi-controller #rates-panel .box .calculate-section .enter-values-box {
  border: 1px solid #7f7f7f;
  margin: 40px 0;
  color: #7f7f7f;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .enter-values {
  position: relative;
  top: -14px;
  background-color: #fff;
  color: #56c271;
  width: 200px;
  text-align: center;
  margin: 0 auto;
  font-size: 22px;
}

@media screen and (max-width: 767px) {
  #roi-controller #rates-panel .box .calculate-section .enter-values-box {
    border: none;
  }

  #roi-controller #rates-panel .box .calculate-section .enter-values-box hr {
    display: none;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .enter-values {
    font-size: 20px;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .enter-values.adjust-loan {
  top: 20px;
  width: 300px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column {
  margin: 20px 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column {
  text-align: center;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  label {
  font-size: 22px;
  font-family: AvenirNext-DemiBold;
  padding-right: 5px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  label[for="numberOfUnits"] {
  padding: 5px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  input {
  height: 45px;
  border: 1px solid #7f7f7f;
  color: #56c271;
  font-size: 22px;
  font-family: AvenirNext-DemiBold;
  width: 65%;
  padding: 0 10px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  input::-webkit-input-placeholder {
  color: #56c271;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  input::-moz-placeholder {
  color: #56c271;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  input.over {
  border: 1px solid red;
  color: red;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  h5 {
  font-size: 18px;
  margin-bottom: 5px;
  height: 50px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  h5.over {
  color: red;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  h5.error {
  display: none;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .input-values.three-column
  .column
  h5.error.over {
  display: block;
  margin-top: 20px;
  padding: 0 70px;
  text-align: left;
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .input-values.three-column
    .column
    h5.error.over {
    padding: 0 20px;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column {
  margin: 40px 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column {
  text-align: center;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column
  .calc-heading {
  font-size: 18px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 31.76157%;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column:last-child {
  margin-right: 0;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .input-values.three-column
    .column
    h5.error.over {
    padding: 0;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-term-column {
    float: left;
    display: block;
    margin-right: 7.42297%;
    width: 100%;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-term-column:last-child {
    margin-right: 0;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .calc-heading {
  padding: 0 80px 0 0;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-term-column
    .loan-term
    .calc-heading {
    padding: 0;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button {
  padding: 10px 35px;
  border: 1px solid #7f7f7f;
  color: #7f7f7f;
  cursor: pointer;
  display: block;
  max-width: 170px;
  margin: 10px auto;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button:hover {
  background-color: #ebe9e4;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button.twelve {
  border: 1px solid #dedede;
  color: #dedede;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-term-column
    .loan-term
    .pill-button {
    display: inline-block;
    min-width: 100px;
    max-width: 130px;
    padding: 10px 18px;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-term-column
    .loan-term
    .pill-button.twelve {
    margin-left: 15px;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button.twelve:hover {
  background-color: #fff;
  cursor: default;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button.twelve.active {
  border: 1px solid #7f7f7f;
  color: #7f7f7f;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button.twelve.active:hover {
  cursor: pointer;
  background-color: #ebe9e4;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button.selected {
  border: 1px solid #56c271 !important;
  color: #56c271 !important;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .pill-button.selected:hover {
  cursor: pointer !important;
  background-color: #e6f6ea !important;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .twelve-error {
  display: block;
  padding: 0 70px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-term-column
  .loan-term
  .twelve-error
  p {
  font-size: 14px;
  font-family: AvenirNext-DemiBold;
  color: #dedede;
  line-height: 18px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.fee-rate-column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 23.23176%;
  text-align: left;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.fee-rate-column:last-child {
  margin-right: 0;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-term-column
    .loan-term
    .twelve-error {
    padding: 0 10px;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.fee-rate-column {
    float: left;
    display: block;
    margin-right: 7.42297%;
    width: 100%;
    text-align: center;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.fee-rate-column:last-child {
    margin-right: 0;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 40.29137%;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column:last-child {
  margin-right: 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table {
  padding-right: 50px;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-table-column {
    float: left;
    display: block;
    margin-right: 7.42297%;
    width: 100%;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-table-column:last-child {
    margin-right: 0;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-table-column
    .calc-table {
    padding: 0;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .error {
  display: none;
  color: red;
  font-size: 18px;
  padding: 0 20px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .error.over {
  display: block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals {
  padding: 20px 0;
  margin: 0;
  border-top: 1px solid #7f7f7f;
  background-color: #fff;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 31.76157%;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .column:last-child {
  margin-right: 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .column.left {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 65.88078%;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .column.left:last-child {
  margin-right: 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .calc-heading {
  font-size: 16px;
  font-family: AvenirNext-DemiBold;
  text-align: left;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-table-column
    .calc-table
    .two-column
    .greyTotals {
    border-top: 1px solid #979797;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-table-column
    .calc-table
    .two-column
    .greyTotals
    .calc-heading {
    font-size: 18px;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .amount
  span {
  color: #7f7f7f;
  font-size: 22px;
  display: none;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .greyTotals
  .amount
  span.display {
  display: block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row {
  padding: 0 0 20px;
  margin: 0;
  border-bottom: none;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 31.76157%;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column:last-child {
  margin-right: 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column.left {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 65.88078%;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column.left:last-child {
  margin-right: 0;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column
  .calc-heading.text-right
  span {
  font-size: 22px;
  font-family: AvenirNext-DemiBold;
  display: none;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column
  .calc-heading.text-right
  span.display {
  display: block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column.loan-table-column
  .calc-table
  .two-column
  .calc-table-row
  .column
  .calc-heading.smaller {
  font-size: 16px;
  text-align: left;
  font-family: AvenirNext-DemiBold;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .adjust-details.three-column
    .column.loan-table-column
    .calc-table
    .two-column
    .calc-table-row
    .column
    .calc-heading.smaller {
    font-size: 18px;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .adjust-details.three-column
  .column
  .loan-popup-trigger
  .calc-heading {
  color: #56c271;
  font-size: 14px;
  cursor: pointer;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .calculate-roi {
  margin: 10px 0 40px;
  text-align: center;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .calculate-roi
  .pill-button {
  padding: 10px 35px;
  cursor: pointer;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .calculate-roi
  .pill-button.roi-enabled {
  opacity: 0.5;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .calculate-roi
  .pill-button.reset {
  display: none;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .calculate-roi
  .pill-button.reset.reset-enabled {
  display: inline-block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section {
  display: none;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.display {
  display: block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column {
  background-color: #f3f3f3;
  padding: 40px 0;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column {
    padding: 20px;
    margin-left: -9%;
    margin-right: -9%;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column {
  text-align: center;
  font-size: 18px;
  padding: 30px 0;
  max-height: 140px;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column {
    padding: 5px 0;
    margin-bottom: 10px;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column.roi {
    border-top: 1px solid #979797;
    padding-top: 20px;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .amount,
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .calc-heading {
    display: inline-block;
    width: 45%;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .calc-heading {
    text-align: left;
    font-size: 18px;
    vertical-align: top;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .amount {
    text-align: right;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount
  span {
  display: none;
  font-size: 36px;
  color: #666;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .amount
    span {
    font-size: 22px;
    font-family: AvenirNext-DemiBold;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount
  span.display {
  display: block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount
  span.active {
  display: none;
  font-size: 36px;
  color: #666;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .amount
    span.active {
    font-size: 22px;
  }
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount
  span.active.display {
  display: block;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount
  span.blank-dashes {
  font-size: 36px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount.roi-calc
  span {
  margin-bottom: 15px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount.roi-calc
  span.roi-percent {
  font-size: 18px;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount.roi-calc
  span.negative-roi {
  color: red;
  font-family: AvenirNext-DemiBold;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column
  .amount.roi-calc
  span.positive-roi {
  color: #56c271;
  font-family: AvenirNext-DemiBold;
}

.rates-terms.emerald.med-hi .mobile-circle .paragraph,
.rates-terms.hero-panel-home.rates-terms-hero .two-column .paragraph {
  font-family: AvenirNext-DemiBold, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-weight: 400;
  font-style: normal;
}

#roi-controller
  #rates-panel
  .box
  .calculate-section
  .enter-values-box
  .roi-section.three-column
  .column.investment {
  border-left: 1px solid #7f7f7f;
  border-right: 1px solid #7f7f7f;
}

@media screen and (max-width: 767px) {
  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column
    .amount.roi-calc
    span {
    margin-bottom: 5px;
  }

  #roi-controller
    #rates-panel
    .box
    .calculate-section
    .enter-values-box
    .roi-section.three-column
    .column.investment {
    border: none;
  }
}

#roi-controller .icon-roi-popup {
  color: #56c271;
  padding-left: 3px;
  font-size: 17px;
  cursor: pointer;
  cursor: hand;
}

#roi-controller .roi-popup {
  padding: 0;
  max-width: inherit;
  min-height: inherit;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 800px;
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  #roi-controller .roi-popup {
    width: 97%;
  }
}

@media screen and (max-width: 767px) {
  #roi-controller .roi-popup {
    width: 97%;
  }
}

#roi-controller .roi-popup .hamburger-box {
  top: 25px;
  left: -25px;
}

#roi-controller .roi-popup .hamburger-box span,
#roi-controller .roi-popup .hamburger-box span::after {
  background-color: #fff;
}

#roi-controller .roi-popup .popup-heading {
  background-color: #56c271;
  color: #fff;
  text-align: left;
  width: 100%;
  padding: 20px 30px;
}

#roi-controller .roi-popup .popup-body {
  padding: 20px 30px 40px;
  font-size: 18px;
}

#roi-controller .roi-popup .popup-body .calculation {
  margin-bottom: 20px;
}

#roi-controller .roi-popup .popup-body .calculation:last-child {
  border-bottom: 0;
  padding-top: 40px;
  border-top: 1px solid #7f7f7f;
}

#roi-controller .roi-popup .popup-body .calculation:last-child .green span {
  top: -10px;
  position: relative;
}

#roi-controller .roi-popup .popup-body .rect {
  display: inline-block;
  height: 88px;
}

#roi-controller .roi-popup .popup-body .rect.bottom {
  top: -23px;
  position: relative;
}

#roi-controller .roi-popup .popup-body .roi-box {
  border: 2px solid grey;
  padding: 30px;
}

#roi-controller .roi-popup .popup-body .roi-box.green {
  width: 170px;
  color: #56c271;
  border: 2px solid #56c271;
}

@media screen and (max-width: 767px) {
  #roi-controller .roi-popup .popup-body .calculation {
    margin-bottom: 40px;
  }

  #roi-controller .roi-popup .popup-body .rect {
    display: block;
  }

  #roi-controller .roi-popup .popup-body .rect.bottom {
    top: auto;
  }

  #roi-controller .roi-popup .popup-body .roi-box.green {
    width: 100%;
  }
}

#roi-controller .roi-popup .popup-body .roi-box.roi-invest {
  padding: 20px;
}

#roi-controller .roi-popup .popup-body .roi-box.roi-box-combined {
  width: 326px;
}

#roi-controller .roi-popup .popup-body .roi-box.roi-box-combined div {
  display: inline-block;
  position: relative;
  top: -10px;
}

#roi-controller .roi-popup .popup-body .roi-box.roi-box-combined .symbol {
  position: relative;
  top: -10px;
}

#roi-controller .roi-popup .popup-body .roi-box.roi-box-combined.mobile {
  display: none;
}

@media screen and (max-width: 767px) {
  #roi-controller .roi-popup .popup-body .roi-box.roi-box-combined {
    width: 100%;
  }

  #roi-controller .roi-popup .popup-body .roi-box.roi-box-combined.mobile {
    display: block;
  }

  #roi-controller .roi-popup .popup-body .roi-box.roi-box-combined.desktop {
    display: none;
  }
}

#roi-controller
  .roi-popup
  .popup-body
  .roi-box.roi-box-combined.mobile
  .invest-amount,
#roi-controller
  .roi-popup
  .popup-body
  .roi-box.roi-box-combined.mobile
  .roi-amount {
  position: absolute;
  width: 170px;
}

#roi-controller
  .roi-popup
  .popup-body
  .roi-box.roi-box-combined.mobile
  .roi-amount {
  margin: -5px 0 0 -65%;
}

#roi-controller
  .roi-popup
  .popup-body
  .roi-box.roi-box-combined.mobile
  .invest-amount {
  margin: 15px 0 0 -115%;
}

#roi-controller
  .roi-popup
  .popup-body
  .roi-box.roi-box-combined.mobile
  .symbol {
  position: relative;
  top: 10px;
}

#roi-controller
  .roi-popup
  .popup-body
  .roi-box.roi-box-combined.mobile
  .symbol.roi-invest-symbol {
  top: 22px;
}

#roi-controller .roi-popup .symbol {
  font-size: 50px;
  color: #56c271;
  padding: 0 20px;
}

#roi-controller .roi-popup.large {
  width: 900px;
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  #roi-controller .roi-popup.large {
    width: 97%;
  }
}

@media screen and (max-width: 767px) {
  #roi-controller .roi-popup .symbol {
    padding: 20px;
  }

  #roi-controller .roi-popup.large {
    width: 97%;
  }
}

.rates-terms.hero-panel-home.rates-terms-hero .two-column .paragraph {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 57.35098%;
  font-size: 18px;
}

.rates-terms.hero-panel-home.rates-terms-hero
  .two-column
  .paragraph:last-child {
  margin-right: 0;
}

@media screen and (max-width: 767px) {
  .rates-terms.hero-panel-home.rates-terms-hero {
    padding-top: 100px;
  }

  .rates-terms.hero-panel-home.rates-terms-hero .hero-text h1 {
    height: 80px;
  }

  .rates-terms.hero-panel-home.rates-terms-hero .two-column .paragraph {
    display: none;
  }
}

.rates-terms.hero-panel-home.rates-terms-hero .two-column .paragraph p {
  padding-right: 100px;
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  .rates-terms.hero-panel-home.rates-terms-hero .two-column .paragraph {
    font-size: 16px;
  }

  .rates-terms.hero-panel-home.rates-terms-hero .two-column .paragraph p {
    padding-right: 0;
  }
}

.rates-terms.hero-panel-home.rates-terms-hero .two-column .questions {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 40.29137%;
}

.rates-terms.hero-panel-home.rates-terms-hero
  .two-column
  .questions:last-child {
  margin-right: 0;
}

.rates-terms.emerald.med-hi {
  max-height: 1000px;
  margin-left: 0 !important;
  min-height: 367px;
  z-index: 9;
}

@media screen and (max-width: 767px) {
  .rates-terms.hero-panel-home.rates-terms-hero .two-column .questions {
    float: left;
    display: block;
    margin-right: 7.42297%;
    width: 100%;
    text-align: left;
  }

  .rates-terms.hero-panel-home.rates-terms-hero
    .two-column
    .questions:last-child {
    margin-right: 0;
  }

  .rates-terms.hero-panel-home.rates-terms-hero .two-column .questions span {
    font-size: 16px;
  }

  .rates-terms.hero-panel-home.rates-terms-hero .two-column .questions .number {
    font-size: 22px;
  }

  .rates-terms.emerald.med-hi {
    padding: 30px 0 55px;
  }
}

.rates-terms.emerald.med-hi .mobile-circle {
  display: none;
}

.rates-terms.emerald.med-hi .mobile-circle .paragraph {
  font-size: 18px;
  padding: 0 10px;
}

@media screen and (max-width: 767px) {
  .rates-terms.emerald.med-hi .mobile-circle {
    display: block;
    margin: 5px 0 30px;
  }

  .rates-terms.emerald.med-hi .three-column {
    padding: 0 10px;
  }

  .rates-terms.emerald.med-hi .three-column .desktop-hide {
    display: none;
  }
}

.rates-terms.emerald.med-hi .three-column .text {
  padding-top: 50px;
}

@media screen and (max-width: 767px) {
  .rates-terms.emerald.med-hi .three-column .text {
    text-align: center;
    padding-top: 0;
  }

  .rates-terms.emerald.med-hi {
    min-height: 1100px;
  }
}

@media screen and (max-width: 320px) {
  .rates-terms.emerald.med-hi {
    min-height: 1200px;
  }
}

@media screen and (min-width: 1068px) {
  .rates-terms.emerald.med-hi {
    margin-left: 60px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  .rates-terms.emerald.med-hi .three-column .text.left {
    padding: 50px 30px 0 0;
  }

  .rates-terms.emerald.med-hi .three-column .text.right {
    padding: 50px 0 0 30px;
  }

  .rates-terms.emerald.med-hi {
    margin-left: 0;
  }
}

@media screen and (max-width: 900px) {
  .rates-terms.emerald.med-hi {
    margin-left: 0;
  }
}

.rates-terms.emerald.med-hi .ways {
  font-size: 22px;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  border: 2px solid #fff;
  padding-top: 50px;
  font-family: Serifa-Roman, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
}

.straight-fees.rates-terms .tables table .bottom-row td,
.straight-fees.rates-terms span {
  font-family: AvenirNext-Regular, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  .rates-terms.emerald.med-hi .ways {
    width: 225px;
    height: 225px;
    padding-top: 45px;
  }
}

@media screen and (max-width: 767px) {
  .rates-terms.emerald.med-hi .ways {
    margin: 0 auto;
  }
}

.rates-terms.emerald.med-hi .ways .larger,
.rates-terms.emerald.med-hi .ways .small {
  display: block;
  text-align: center;
}

.rates-terms.emerald.med-hi .ways .larger {
  background-color: #56c271;
  margin: 20px auto;
  font-size: 35px;
}

.rates-terms.emerald.med-hi .ways .larger span {
  font-size: 65px;
  line-height: 50px;
  vertical-align: middle;
}

.rates-terms.emerald.med-hi .ways.way-one {
  margin: 0 auto;
}

.rates-terms.emerald.med-hi .ways.way-one .larger {
  max-width: 185px;
}

.rates-terms.emerald.med-hi .ways.way-one .larger .k-span {
  vertical-align: sub;
  font-size: 32px;
}

.straight-fees.rates-terms .no-interest {
  line-height: 1.6em;
  margin-bottom: 50px;
}

@media screen and (max-width: 767px) {
  .straight-fees.rates-terms .straight-fees {
    font-size: 28px;
  }

  .straight-fees.rates-terms .no-interest {
    font-size: 24px;
    padding: 0 10px;
  }

  .straight-fees.rates-terms .two-column {
    padding: 0 10px;
  }

  .straight-fees.rates-terms .tables .desktop-table {
    display: none;
  }
}

.straight-fees.rates-terms span {
  font-style: normal;
}

.straight-fees.rates-terms .mobile-top-text {
  text-align: center;
}

.straight-fees.rates-terms .mobile-top-text p {
  font-size: 18px;
}

.straight-fees.rates-terms .tables h5 {
  color: #56c271;
}

.straight-fees.rates-terms .tables h5 span {
  font-size: 16px;
  color: #666;
}

.straight-fees.rates-terms .tables .desktop-table {
  border-spacing: 0;
}

.straight-fees.rates-terms .tables .mobile-table {
  margin-top: 15px;
}

.straight-fees.rates-terms .tables .mobile-table .title-column {
  text-align: left;
  font-size: 14px;
}

.straight-fees.rates-terms .tables table td,
.straight-fees.rates-terms .tables table td:last-child {
  text-align: center;
}

.straight-fees.rates-terms .tables .mobile-table td,
.straight-fees.rates-terms .tables .mobile-table th {
  font-size: 14px;
}

.straight-fees.rates-terms .tables .mobile-table .green-column {
  background-color: #56c271;
  padding: 2px 10px;
}

@media screen and (max-width: 767px) {
  .straight-fees.rates-terms .tables .mobile-table .green-column {
    color: #fff;
  }

  .straight-fees.rates-terms .text .top-text {
    display: none;
  }
}

.straight-fees.rates-terms .tables .mobile-table .tan-column {
  background-color: #ebe9e4;
  padding: 2px 10px;
}

.straight-fees.rates-terms .tables table {
  width: 100%;
}

.straight-fees.rates-terms .tables table .green-row {
  background-color: #56c271;
  padding: 5px 0;
}

.straight-fees.rates-terms .tables table .green-row td {
  color: #fff;
  padding: 5px 0;
}

.straight-fees.rates-terms .tables table .bottom-row td {
  font-style: normal;
}

.six-twelve-terms .six-twelve-graphs .column table .month,
.six-twelve-terms .six-twelve-graphs .mobile-table .title-column,
.straight-fees.rates-terms .tables table td,
.straight-fees.rates-terms .tables table th {
  font-family: AvenirNext-DemiBold, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  font-style: normal;
  font-weight: 400;
}

.straight-fees.rates-terms .tables table th {
  width: 50px;
}

.straight-fees.rates-terms .tables .top-table table {
  margin-bottom: 10px;
}

.straight-fees.rates-terms .tables .top-table hr {
  margin-bottom: 70px;
  border: 1px solid #b3b3b3;
}

.straight-fees.rates-terms .tables .bottom-table hr {
  border: 1px solid #b3b3b3;
}

@media screen and (min-width: 768px) {
  .straight-fees.rates-terms .mobile-top-text,
  .straight-fees.rates-terms .tables .mobile-table {
    display: none;
  }

  .straight-fees.rates-terms .text {
    padding: 0 40px;
  }

  .straight-fees.rates-terms .text .top-text {
    margin-bottom: 40px;
  }
}

.straight-fees.rates-terms .text h5 {
  text-align: left;
}

.straight-fees.rates-terms .text p {
  font-size: 16px;
  padding: 5px 0;
  text-align: left;
}

.straight-fees.rates-terms .arrow-down {
  width: 0;
  height: 0;
  margin: 0 auto 55px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid #56c271;
}

.straight-fees.rates-terms h2 {
  text-align: center;
  font-size: 44px;
  color: #56c271;
}

.straight-fees.rates-terms p {
  text-align: center;
  font-size: 28px;
}

@media screen and (min-width: 768px) {
  .straight-fees.rates-terms p {
    padding: 0 140px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1067px) {
  .straight-fees.rates-terms p {
    padding: 0 10px;
  }
}

.straight-fees .bottom-title-button {
  text-align: center;
  margin: 60px 0 50px;
}

.straight-fees .loan-calc-button {
  margin-top: 20px;
  position: relative;
}

.straight-fees .loan-calc-button .column {
  float: left;
  display: block;
  margin-right: 2.35765%;
  width: 100%;
  text-align: center;
  position: absolute;
  margin-top: -25px;
}

.straight-fees .loan-calc-button .column:last-child {
  margin-right: 0;
}

.straight-fees .loan-calc-button .pill-button {
  padding: 10px 35px;
}
</style>


// WEBPACK FOOTER //
// loanCalculator.vue?1f0e587b